import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings'

export const SearchResultComponentStyled = styled('div')({
  fontSize: '1.2rem',
  backgroundColor: hexColors.white,
  padding: '0.5rem 0.75rem',
  borderBottom: `1px solid ${hexColors.gainsboro}`,
})
